import type { ModeTokens } from '../tokens';

const stoneRose: ModeTokens = {
  light: {
    surface: {
      base: '#F7F3EE',
      raised: '#FFFDF9',
      sunken: '#ECE4D8',
      overlay: 'rgba(28,25,23,0.45)',
    },
    text: {
      primary: '#231E1B',
      secondary: '#5B524B',
      muted: '#6F655D',
      onAccent: '#FFFDF9',
      onDanger: '#FFFDF9',
    },
    border: {
      subtle: '#E9E0D5',
      default: '#D2C6B7',
      strong: '#A4988A',
      focus: '#9C5958',
    },
    accent: {
      default: '#9C5958',
      hover: '#865049',
      pressed: '#7F4746',
      soft: '#EADBD9',
    },
    status: {
      success: { bg: '#E3EADB', fg: '#37522A' },
      warning: { bg: '#F5E6D0', fg: '#70461C' },
      danger: { bg: '#F0D8D6', fg: '#7D312E' },
      info: { bg: '#E1DDE8', fg: '#41365A' },
    },
  },
  dark: {
    surface: {
      base: '#1C1917',
      raised: '#252220',
      sunken: '#141211',
      overlay: 'rgba(0,0,0,0.6)',
    },
    text: {
      primary: '#F3EBE2',
      secondary: '#B0A598',
      muted: '#A39789',
      onAccent: '#1C1917',
      onDanger: '#1C1917',
    },
    border: {
      subtle: '#332F2C',
      default: '#413C38',
      strong: '#655C54',
      focus: '#C98582',
    },
    accent: {
      default: '#C98582',
      hover: '#DBA19E',
      pressed: '#E8B7B4',
      soft: '#3A2F2D',
    },
    status: {
      success: { bg: '#273229', fg: '#BBD5C0' },
      warning: { bg: '#3A2E1A', fg: '#E9C88B' },
      danger: { bg: '#3B2522', fg: '#F0B3AD' },
      info: { bg: '#2B2736', fg: '#C5B9DC' },
    },
  },
};

export default stoneRose;
